import { render, staticRenderFns } from "./TenancyDepositRouter.vue?vue&type=template&id=a4a1a2c4&"
import script from "./TenancyDepositRouter.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports